import withResolvers from 'core-js-pure/actual/promise/with-resolvers';

// Use an explicit value import: CRA's target-based polyfill pass removes bare
// core-js imports for its modern development targets, including Samsung's missing API.
// This must run before React/PDF.js; PDF.js constructs loading tasks in effects.
if (typeof Promise.withResolvers !== 'function') {
  Object.defineProperty(Promise, 'withResolvers', {
    configurable: true, writable: true, value: withResolvers,
  });
}
